<template>
  <div class="top-bar">
    <router-link to="/" tag="h1" class="top-logo">
      <img src="@images/rebuild/logo.png" alt="" class="logo-img" />
    </router-link>

    <!-- <router-link to="/location" tag="div" class="change-city-btn">
      <img src="@images/logo.png" alt="logo" class="logo" />
      <span class="city">{{city}}</span>
    </router-link> -->

    <div v-if="noLogin" class="user-area">
      <router-link to="/login" class="login-btn">登录</router-link>
    </div>
    <div v-else class="user-area">
      <!-- <span class="nickname mr10">{{nickname}}</span> -->
      <div class="logout" @click="logOut">退出</div>
    </div>
    <div v-else class="user-ctrl only-desktop">
      <div class="user-avatar">
        <img src="@images/default_avatar.png" alt="" class="avatar-img" />
      </div>
      <div :class="showLogout ? 'ctrl-btn active' : 'ctrl-btn'" @click="logToggle"></div>
      <div v-if="showLogout" class="logout-btn" @click="logOut">退出</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'TopBar',
  data() {
    return {
      city: '',
      showLogout: false,
    }
  },
  computed: {
    ...mapState(['currentCity', 'authorization', 'nickname']),
    noLogin() {
      return this._.isEmpty(this.authorization)
    },
  },
  methods: {
    ...mapMutations(['removeAuthorization', 'removeNickname', 'removeMobile', 'removeOpenid']),
    ...mapActions(['resetToken']),
    logToggle() {
      console.log(this.showLogout)
      this.showLogout = !this.showLogout
    },
    logOut() {
      let logoutConfirm = confirm('确定要退出？')
      if (logoutConfirm) {
        this.resetToken().then(() => {
          location.href = '/'
        })
      }
    },
    trackingAction(action) {
      _jcq.push(['_track', action])
    },
  },
  mounted() {
    // if (!this._.isEmpty(this.currentCity)) {
    //   this.city = this.currentCity.city
    // } else {
    //   this.city = '选择城市'
    // }
  },
}
</script>

<style lang="scss" scoped>
.top-bar {
  position: fixed;
  z-index: 11;
  top: 0;
  left: 0;
  width: 100%;
  height: $top-height-descktop;
  padding: 0 15px;
  align-items: center;
  justify-content: space-between;
  background: rgba(0, 17, 67, 0.3);
  // background: nth($pink, 1) url('~@images/rebuild/web/top_bar.png') no-repeat center top;
  // background-size: auto 100%;
}
.top-title {
  display: none;
  position: absolute;
  z-index: 0;
  left: 0;
  @include center(y);
  width: 100%;
  text-align: center;
  font-weight: 900;
  font-size: 2.6rem;
  color: #fff;
  text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.75);
  @include respond-to(desktop) {
    display: block;
    cursor: pointer;
    font-size: 4rem;
  }
}
.top-logo {
  position: absolute;
  @include center(x);
  top: 45px;
  height: 28px;
  cursor: pointer;
  .logo-img {
    height: 100%;
  }
}
.change-city-btn {
  display: inline-block;
  position: relative;
  padding-right: 20px;
  font-family: 'AbsolutHeadline';
  font-size: 2.6rem;
  letter-spacing: -0.02em;
  color: #fff;
  cursor: pointer;
  .logo {
    height: 32px;
    @include respond-to(desktop) {
      height: 48px;
    }
  }
  .city {
    display: inline-block;
    margin-left: 12px;
    vertical-align: middle;
    font-size: 2rem;
    font-weight: bold;
    text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.75);
    @include respond-to(desktop) {
      font-size: 3rem;
    }
  }
  &:after {
    position: absolute;
    @include center(y);
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 6px 4px 0 4px;
    border-color: currentColor transparent transparent transparent;
    content: '';
    @include transition(0.4s);
    overflow: hidden;
    @include respond-to(desktop) {
      border-width: 8px 6px 0 6px;
    }
  }
}
.user-area {
  position: absolute;
  top: 45px;
  right: 45px;
  z-index: 1;
}
.user-ctrl {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 1;
  .user-avatar {
    display: inline-block;
    width: 56px;
    height: 56px;
    margin-right: 10px;
    border: 2px solid #fff;
    border-radius: 50%;
    vertical-align: middle;
    overflow: hidden;
    .avatar-img {
      width: 100%;
      height: 100%;
    }
  }
  .ctrl-btn {
    display: inline-block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 6px 0 6px;
    border-color: #fff transparent transparent transparent;
    vertical-align: middle;
    cursor: pointer;
    @include transition(0.4s);
    @include transform(rotate(0));
    &.active {
      @include transform(rotate(-180deg));
    }
  }
  .logout-btn {
    position: absolute;
    z-index: 1;
    left: 50%;
    bottom: -50px;
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: -60px;
    text-align: center;
    font-weight: bold;
    font-size: 2rem;
    color: #fff;
    background: #9e28b5;
    cursor: pointer;
  }
}
.login-btn,
.reg-btn,
.nickname,
.logout {
  display: inline-block;
  font-size: 1.4rem;
  // font-size: $font-nm-l;
  color: #37d32f;
  letter-spacing: 0.115em;
}
.logout {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue